import styled from 'styled-components';


export const PopupContainer = styled.div`
  position: fixed;
  right: 2%;
  bottom: 2%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #25D366;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;